import React from 'react';
import './Icon.scss';

export type IconColor = 'primary' | 'secondary' | 'info' | 'warning' | 'error' | 'success' | 'muted' | 'inherit';
export type IconSize = 'sm' | 'md' | 'lg' | 'xl';

export type IconBaseProps = {
    children: React.ReactNode;
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconBase: React.FC<IconBaseProps> = ({
    children,
    color = 'primary',
    size = 'md',
    className = '',
    title
}) => {
    return (
        <span
            className={`icon icon--${color} icon--${size} ${className}`.trim()}
            title={title}
        >
            {children}
        </span>
    );
};

export default IconBase;

